import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.vendorInfoController;
const getController = self.customSetting.getVendorInfo;
const postController = self.customSetting.postVendorInfo;

export default {
  // 1-2
  getAccCensorData: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/GetVerifyList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getAccCensorDataDetail: (context, id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/GetVerifyDetail?work_no=${id}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  censorAccount: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdVerifyDetail`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // 廠商基本資料修改如果身分是廠商事先取得廠商的資料
  initVendorInfo: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/Init`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 1-3
  vendorInfoGetSupplier: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getController}/GetSupplier?current=${obj.current}&count=${obj.count}&word=${obj.word}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  vendorInfoExportVendor: (context, data) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${baseApi}/${postController}/ExportVendor`,
        method: "POST",
        responseType: "blob",
        data: data,
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getVdrEmpList: (context, s_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/GetVdrEmpList?s_id=${s_id}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  deleteCourse: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/DeleteCourse`, obj)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  insEmployee: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/InsEmployee`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getEmployeeDetail: (context, { s_id, id }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getController}/GetEmployeeDetail?s_id=${s_id}&id=${id}`
        )
        .then((res) => {
          context.commit("GET_EMPLOYEE_DETAIL", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  modifyEmployeeInfo: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/ModifyEmployeeInfo`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSupplierDetail: (context, s_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/GetSupplierDetail?s_id=${s_id}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  resetPD: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/restPD?p=${data}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  updSupplierDetail: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdSupplierDetail`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSiteManager: (context, s_Id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/GetSiteManager?s_Id=${s_Id}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 1-4
  getAccCensorHistory: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/GetVerifyHistoryList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getAccCensorHistoryDetail: (context, id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/GetHistoryVerifyDetail?work_no=${id}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
